import styled from "styled-components";

export const TaskSelector = styled.div`
  position: relative;
  margin-top: 3rem;
  display: flex;
  align-self: flex-start;
  left: 2.5%;
  padding-bottom: 11px;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 15.4809px;
  line-height: 20px;
  border-bottom: 1px solid #a9aeb4;
  user-select: none;
`;

export const TaskInExectution = styled.span`
  margin-left: 0rem;
  text-align: center;
  cursor: pointer;
  
  color: ${({ TaskSelectorState }) =>
    TaskSelectorState === "doing" ? "#212326" : "#A9AEB4"};
`;

export const TaskDelayed = styled.span`
  margin-left: 4rem;
  text-align: center;
  cursor: pointer;

  @media (min-width: 1920px) {
    margin-left: 3rem;
  }

  color: ${({ TaskSelectorState }) =>
    TaskSelectorState === "late" ? "#212326" : "#A9AEB4"};
`;

export const TaskPending = styled.span`
  margin-left: 4rem;
  text-align: center;
  cursor: pointer;

  @media (min-width: 1920px) {
    margin-left: 3rem;
  }

  color: ${({ TaskSelectorState }) =>
    TaskSelectorState === "pending" ? "#212326" : "#A9AEB4"};
`;
export const TaskConcluded = styled.span`
  margin-left: 4rem;
  text-align: center;
  cursor: pointer;

  @media (min-width: 1920px) {
    margin-left: 3rem;
  }

  color: ${({ TaskSelectorState }) =>
    TaskSelectorState === "done" ? "#212326" : "#A9AEB4"};
`;

export const TaskUnderline = styled.div`
  position: absolute;
  border-radius: 0.4rem;
  background-color: #40e5a0;
  border-bottom: 3px solid #40e5a0;
  transform: translateY(30px);
  height: 0%;
  bottom: -1;
  pointer-events: none;
  z-index: 1;
  transition: 0.3s ease-out;
`;
